import { render, staticRenderFns } from "./RechargeReview.vue?vue&type=template&id=ad4ee872&"
import script from "./RechargeReview.vue?vue&type=script&lang=js&"
export * from "./RechargeReview.vue?vue&type=script&lang=js&"
import style0 from "./RechargeReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports